var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMegaphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m403.172 105.94 32.134-32.133c5.858-5.858 5.858-15.355 0-21.213-5.857-5.858-15.355-5.857-21.213 0l-32.134 32.133c-5.858 5.857-5.858 15.355 0 21.213 5.856 5.857 15.354 5.859 21.213 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m472.9 176.733h-32.134c-8.284 0-15 6.716-15 15s6.716 15 15 15h32.134c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296.166 62.133c8.284 0 15-6.716 15-15v-32.133c0-8.284-6.716-15-15-15s-15 6.716-15 15v32.133c0 8.284 6.716 15 15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.492 373.927c-5.853 5.852-5.858 15.356 0 21.213l64.267 64.267c5.856 5.857 15.354 5.859 21.213 0l25.136-25.135-85.479-85.479z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288.194 386.038-105.327 49.566 72.003 72.003c5.856 5.857 15.355 5.859 21.213 0l56.233-56.233c5.858-5.858 5.858-15.355 0-21.213z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.439 52.594c-3.454-3.454-8.374-5.009-13.186-4.17-4.812.84-8.913 3.97-10.993 8.39l-127.419 270.764 85.479 85.48 270.765-127.419c4.42-2.08 7.55-6.182 8.39-10.994s-.716-9.731-4.17-13.185z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.c659a478.svg";
export { ForwardRef as ReactComponent };